import { render, staticRenderFns } from "./ArticoloExtra.vue?vue&type=template&id=0dbecb82&scoped=true&"
import script from "./ArticoloExtra.vue?vue&type=script&lang=js&"
export * from "./ArticoloExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbecb82",
  null
  
)

export default component.exports